import SupportProgressiveDisclosureSnippet from "snippets/support-progressive-disclosure.mdx";
import * as React from 'react';
export default {
  SupportProgressiveDisclosureSnippet,
  React
};